/**
 * Promise.try polyfill — required by pdfjs-dist 6.x.
 * Native support landed in Chrome 130 / Firefox 132 / Safari 18.2.
 * This shim covers older browsers still in use.
 * Spec: https://tc39.es/proposal-promise-try/
 */
if (!('try' in Promise)) {
  (Promise as unknown as Record<string, unknown>)['try'] = function <T>(
    fn: (...args: unknown[]) => T | PromiseLike<T>,
    ...args: unknown[]
  ): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      try {
        resolve(fn(...args));
      } catch (err) {
        reject(err);
      }
    });
  };
}
